import React from 'react';
import '../App.css';

interface ErrorProps {
    title?: string;
    message: string;
}

const Error: React.FC<ErrorProps> = ({ title = "Error", message }) => {
    return (
        <div className="error-container">
            {/* <div className="error-title">
                {title}
            </div> */}
            <div className="error-message">{message}</div>
        </div>
    );
};

export default Error; 